import styled from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';
import ds from 'designsystem';
import {
  MOBILE_NAV_TRANSITION_FUNCTION,
  MOBILE_NAV_TRANSITION_SPEED,
} from 'common/consts/navigation';


const BurgerIconWrapper = styled.a`
  position: relative;
  display: flex;
  width: 16px;
  height: 16px;
  cursor: pointer;
  justify-content: center;
  padding-bottom: calc(${ds.get('metrics.xs')} * 2);
`;

const BurgerIconElement = styled.span`
  &, &:after, &:before {
    cursor: pointer;
    border-radius: 1px;
    height: 2px;
    width: 16px;
    background-color: ${({ color }) => color || ds.brand('text')};
    position: absolute;
    display: block;
    content: '';
    transition: all ${MOBILE_NAV_TRANSITION_SPEED} ${MOBILE_NAV_TRANSITION_FUNCTION};
    top: 6px;
  }
  
  &:before {
    top: 6px;
  }
  
  &:after {
    top: ${ds.get('metrics.xs')};
  }
  
  ${({ active }) => (active ? `
    & {
      margin-top: ${ds.get('metrics.xs')};
      background-color: transparent;
    }
    &, &:after, &:before {
      top: 0;
      width: 18px;
      height: 2px;
    }
    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  ` : '')}
`;

const BurgerIcon = ({ active, color }) => (
  <BurgerIconWrapper>
    <BurgerIconElement active={active} color={color} />
  </BurgerIconWrapper>
);
BurgerIcon.propTypes = {
  active: PropTypes.bool,
  color: PropTypes.string,
};
BurgerIcon.defaultProps = {
  active: false,
  color: '',
};

export default BurgerIcon;



// WEBPACK FOOTER //
// ./src/blocks/BurgerIcon/index.jsx